// extracted by mini-css-extract-plugin
export var quantityInput = "_o7-0";